import { render } from "./RequestCard.vue?vue&type=template&id=b75538d0&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=b75538d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75538d0"]])

export default __exports__